import { PortalService } from './../../../core/services/portal.service';
import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  backendVersion: string = '';



  constructor(public settings: SettingsService, private portalService: PortalService) { }

  ngOnInit() {
    this.portalService.getBackendVersion().subscribe((response) => {
      const { outcome, version } = response;
      this.backendVersion = version;
    });
  }

}
